const isPhone = value => {
  if (!value) return true;
  return /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(value);
};

export { isPhone };
